module.exports = __webpack_public_path__ + "img/server.18b92a3b.png";